<template>
  <section class="wrapper wrapper-content animated fadeIn">
    <div class="row">
      <div class="col-lg-7 animated fadeInRight">
        <div class="mail-box">
          <table class="table table-hover table-mail">
            <thead class="table-head">
              <tr>
                <th>Nome da Permissão</th>
                <th></th>
                <th></th>
              </tr>
            </thead>

            <tbody class="table-list">
              <tr v-for="(listItem, listIdx) in rolesList" :key="listIdx">
                <td>{{ listItem.name }}</td>
                <td class="list-command">
                  <button
                    class="btn btn-outline"
                    @click="selectRole(listItem, listIdx)"
                  >
                    <i class="fa fa-edit text-success"></i>
                  </button>
                </td>
                <td class="list-command">
                  <button
                    class="btn btn-outline"
                    @click="removeRole(listItem.id)"
                  >
                    <i class="fa fa-trash text-danger"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="col-lg-5">
        <div class="ibox float-e-margins">
          <div class="ibox-content mailbox-content">
            <form>
              <h2>Atualização da Permissão</h2>
              <div class="space-25"></div>

              <div class="form-group">
                <label>Nome da Permissão</label>
                <input
                  type="text"
                  placeholder="Operador Nível II"
                  class="form-control"
                  v-model="form.name"
                />
              </div>

              <button
                v-if="control.hasRoleSelected"
                type="button"
                class="btn btn-block btn-warning compose-mail"
                href="mail_compose.html"
                @click="saveEdition"
              >
                <i class="fa fa-save"></i>
                Salvar
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { toast } from '@/plugins/toast';
export default {
  data() {
    return {
      rolesList: [],
      form: {
        name: '',
      },
      control: {
        hasRoleSelected: false,
        roleId: '',
      },
    };
  },
  mounted() {
    this.loadRoles();
  },

  methods: {
    async loadRoles() {
      const list = await this.$store.dispatch('ROLES/ListRoles');
      this.rolesList = list;
    },

    selectRole(role) {
      this.form.name = role.name;
      this.control.hasRoleSelected = true;
      this.control.roleId = role.id;
    },
    async saveEdition() {
      try {
        const payload = {
          name: this.form.name,
          roleId: this.control.roleId,
        };
        await this.$store.dispatch('ROLES/UpdateRole', payload);
        await this.loadRoles();
      } catch (error) {
        toast.error('Falha ao atualizar nome da Permissão');
      }
    },
    async removeRole(roleId) {
      try {
        await this.$store.dispatch('ROLES/DeleteRole', { roleId });
        await this.loadRoles();
      } catch (error) {
        toast.error('Falha ao remover Permissão');
      }
    },
  },
};
</script>